<template lang="html">
  <div id="d-detail-template-1">
    <div class="box-white-s1">
      <div class="box-image">
        <a :href="row.imageUrl" target="_blank" rel="noopener noreferrer">
          <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+ row.imageUrl +')' }"></div>
        </a>
        <a class="btn btn-sm btn-info" :href="row.documentUrl" target="_blank" style="background-color: black; border-color: black;margin-top: 5px;" v-if="row.documentUrl"> Descargar PDF</a>
      </div>

      <div class="basic-info">
        <h5 class="date">{{ row.created }}</h5>
        <h1 class="title">{{ row.title }}</h1>
      
      </div>

      <div class="box-description" v-html="row.body">
       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        row:{},
        id:null,
    }
  },

  methods: {
   
    getRow(){
      axios.get(tools.url("/api/blogs/"+this.id)).then((response)=>{
          this.row = response.data;
      }).catch(()=>{});
    }
  },
  mounted(){
    this.id=this.$route.params.id;
      this.getRow();
  }
}
</script>
